import React from 'react';
import PropTypes from 'prop-types';
import { Button, Container } from './css';

const ToggleButton = ({
  input,
  label1,
  label2,
  disabled,
  callback,
}) => {
  const handleToggle = (e, index) => {
    e.preventDefault();
    const value = e.target.innerHTML;
    input.onChange(value);
    if (callback) {
      callback(index, value);
    }
  };

  return (
    <Container>
      <Button
        disabled={(disabled || label1 === input.value)}
        onMouseUp={(e) => handleToggle(e, 0)}
        isSelected={(label1 === input.value)}
      >
        {label1}
      </Button>
      <Button
        disabled={(disabled || label2 === input.value)}
        onMouseUp={(e) => handleToggle(e, 1)}
        isSelected={(label2 === input.value)}
      >
        {label2}
      </Button>
    </Container>
  );
};

ToggleButton.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  label1: PropTypes.string,
  label2: PropTypes.string,
  disabled: PropTypes.bool,
  callback: PropTypes.func,
};

export default ToggleButton;
